import {
  Box,
  Button,
  Divider,
  Flex,
  Img,
  Grid,
  Square,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import moment from "moment";
import Badge_Component from "../Badge/Badge_Component";
import * as api from "../../../services/api";
import { Link } from "react-router-dom";
import salary from "../../../Assets/salary_icon2.svg";
import map from "../../../Assets/location.svg";
import monitor from "../../../Assets/monitor.svg";
import people from "../../../Assets/people.svg";
import dot from "../../../Assets/dot.svg";

const ClosedTab_JRComponent = ({ data }) => {
  const levels = [
    "Foundation",
    "3D NFT Creator",
    "3D Environment Creator",
    "XR Interaction Creator",
    "Simulation Creator",
    "Ajna Creator",
  ];
  const [company, setCompany] = useState("");
  const getCompany = async () => {
    const companyData = await api.getCompanyById(data.companyID._id);
    setCompany(companyData.data.data);
  };
  useEffect(() => {
    getCompany();
  }, []);
  const sliceText = (text) => {
    if (text.length >= 200) {
      const sliced = text.slice(0, 201);
      return `${sliced} ...`;
    }
    return text;
  };
  const arr = [1, 2];

  const [hoverState, sethoverState] = useState(false);

  const handleHover = () => {
    sethoverState(true);
  };

  const handleLeave = () => {
    sethoverState(false);
  };

  return (
    <div>
      <Box
        // h={["auto", "auto", 345, 345]}
        w={["95%", "95%", 415, 415]}
        border="1px solid #D9D9D9"
        css={{
          "@media screen and (min-width: 1550px) and (max-width:1980px)": {
            height: 303,
          },
          "@media screen and (min-width: 1280px) and (max-width:1540px)": {
            height: 303,
          },
        }}
        borderRadius={12}
        mx={3}
        my={3}
        p={1}
        _hover={{ boxShadow: "0px 4px 18px rgba(0, 0, 0, 0.13)" }}
        onMouseEnter={handleHover}
        onMouseLeave={handleLeave}
      >
        <Box mx={3} my={1}>
          <Box mt={3}>
            {/* Job Role Component plus Company Name */}
            <Flex justifyContent="left" align={"center"}>
              {/* Logo */}
              <Square
                size={42}
                borderRadius={8}
                border={"1px solid #E7E6E8"}
                overflow={"hidden"}
              >
                <img
                  height={"100%"}
                  width={"100%"}
                  src={company.profilePhoto}
                  alt="logo"
                />
              </Square>
              {/* Name and company */}
              <Box ml={4} w={364}>
                <Text
                  w="auto"
                  fontSize={20}
                  fontWeight={550}
                  textAlign="left"
                  fontFamily={"Roboto"}
                  color={"#0B0019"}
                >
                  {/* {role} */}
                  {data.jobRoleTitle ? sliceText(data.jobRoleTitle) : ""}
                </Text>
                <Flex>
                  <Text
                    fontSize={14}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                    color={"#9D99A3"}
                    textAlign="left"
                  >
                    {company?.companyName}
                  </Text>
                  {/* <Text
                    fontSize={14}
                    fontFamily={"Roboto"}
                    fontWeight={500}
                    color="#767676"
                  >
                    {moment(data.createdAt).format("DD-MM-YYYY")}
                  </Text> */}
                </Flex>
              </Box>
            </Flex>
            {/* ********New ******* */}
            <Flex flexDir={"column"} my={4} gap={1.5}>
              <Flex gap={[2, 2, 2, 2, 6, 6, 6]}>
                {/* salary */}
                <Flex align="center" gap={1}>
                  <img src={salary} alt="salary" />
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                    color="#767676"
                  >
                    Salary -
                  </Text>
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontWeight={550}
                    fontFamily={"Roboto"}
                    color="#767676"
                  >
                    {data.packageOffered} LPA
                  </Text>
                </Flex>
                <Img src={dot} />
                {/* location */}
                <Flex align="center" gap={1}>
                  <img src={map} alt="location" />
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                    color="#767676"
                  >
                    Location -
                  </Text>
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontWeight={550}
                    fontFamily={"Roboto"}
                    color="#767676"
                  >
                    {data.location}
                  </Text>
                </Flex>
              </Flex>

              <Flex gap={[2, 2, 2, 2, 6, 6, 6]}>
                {/* Platform */}
                <Flex align="center" gap={1}>
                  <img src={monitor} alt="platform" />
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                    color="#767676"
                  >
                    Platform -
                  </Text>
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontWeight={550}
                    fontFamily={"Roboto"}
                    color="#767676"
                    textTransform={"capitalize"}
                  >
                    {data.platform}
                  </Text>
                </Flex>
                <Img src={dot} />
                {/* openings */}
                <Flex align="center" gap={1}>
                  <img src={people} alt="platform" />
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                    color="#767676"
                  >
                    Openings -
                  </Text>
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontWeight={550}
                    fontFamily={"Roboto"}
                    color="#767676"
                  >
                    {data.openings}
                  </Text>
                </Flex>
              </Flex>
            </Flex>
            <Box my={2}>
              <Badge_Component num={levels[data.requiredLevel]} />
            </Box>
            {/* Posted On */}
            <Flex my={[2, 2, 4, 4]} gap={2} justify="space-between">
              <Text
                fontSize={[12, 12, 14, 14]}
                fontWeight={500}
                fontFamily={"Roboto"}
                color="#767676"
              >
                Posted on : {moment(data.createdAt).format("DD-MM-YYYY")}
              </Text>
              <Text
                fontSize={[12, 12, 14, 14]}
                fontWeight={500}
                fontFamily={"Roboto"}
                color="#767676"
              >
                Closed on : {moment(data.updatedAt).format("DD-MM-YYYY")}
              </Text>
            </Flex>
            <Box my={[2, 2, 0, 0]}>
              <Link to={`/hiring/recruiter/details/${data._id}`}>
                <Button
                  borderRadius={12}
                  w="100%"
                  h={41}
                  alignItems="center"
                  fontSize={20}
                  fontWeight={500}
                  fontFamily={"Roboto"}
                  letterSpacing={"0.04em"}
                  mb={0}
                  border={hoverState ? "" : "1px solid #E7E6E8"}
                  color={hoverState ? "#FFFFFF" : ""}
                  bg={hoverState ? "#6C56FB" : ""}
                  _hover={{
                    boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                  }}
                >
                  View details
                </Button>
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default ClosedTab_JRComponent;
